
/**
 * Honeypot component for bot protection.
 * It renders a field that is hidden from users but visible to bots.
 * If this field is filled, the submission should be rejected.
 */
const Honeypot = ({ register, name = "company_name" }) => {
    return (
        <div style={{
            display: 'none',
            position: 'absolute',
            left: '-9999px'
        }} aria-hidden="true">
            <input
                type="text"
                tabIndex="-1"
                autoComplete="off"
                {...register(name)}
            />
        </div>
    );
};

export default Honeypot;
